import { useEffect, useMemo, useState } from 'react'
import { Card, StyledBody, StyledAction } from 'baseui/card';
import { CreateObjectDialog } from './CreateObjectDialog';
import { ObjectHeader } from '../../automationObjects/components/ObjectHeader'
import { Grid, Cell } from 'baseui/layout-grid';
import { Search } from 'baseui/icon';
import { Input } from 'baseui/input';
// ui 
import { Tabs, Tab } from "baseui/tabs-motion";
import { APP_GROUPS, IAutomationObject, UnknownAutomationObject } from '../../automationObjects';
import { ObjectTemplatesModal } from './Templates/ObjectTemplatesModal';
import { componentsRegistry } from '../../automationObjects/automationObjectsSelector';
import { Block } from 'baseui/block';
import { useStyletron } from 'baseui';
import { groupBy } from '../../utils/arrayUtils';
import RenderIfVisible from 'react-render-if-visible';
import { FlexGrid, FlexGridItem } from 'baseui/flex-grid';

export const ObjectCreator = (props: {
    object?: IAutomationObject,
    small?: boolean,
    activeTab?: any,
    height?: any,
    hideTemplates?: boolean,
    filter?: (app: IAutomationObject) => boolean | undefined
}) => {
    const { activeTab, hideTemplates, object, small } = props;
    const [css, theme] = useStyletron();
    const [activeKey, setActiveKey] = useState<React.Key>(activeTab);

    const myfilter = props.filter ?? defaultFilter;
    const objects = useMemo(() => Object.values(componentsRegistry).slice()
        .filter((item: any, index: number) => item.createConfig !== undefined)
        .filter((item: any, index: number) => myfilter(item))
        .map((item: any) => {
            return {
                ...item.createConfig,
                schema: item.schema,
            }
        })
        .sort(sortSchema)
        //.sort(sort)
        , []);

    const groupedObjects = useMemo(() => {
        return groupBy(objects, 'group').slice().sort((a, b) => a.key.localeCompare(b.key));
    }, [objects])

    return (
        <Block height={'100%'} gridGap={theme.sizing.scale400} display='flex' flexDirection={'column'}>
            {!hideTemplates && <ObjectTemplatesModal></ObjectTemplatesModal>}
            <Tabs overrides={{
                Root: {
                    style: ({ $theme }) => ({
                        height: `90%`,
                    })
                },
            }}
                activeKey={activeKey}
                onChange={({ activeKey }) => setActiveKey(activeKey)}
                activateOnFocus>
                {groupedObjects.map((item) =>
                    <Tab overrides={tabPanelStyle} title={APP_GROUPS[item.key]} >
                        <GroupView object={object} small={small} objects={item.values}></GroupView>
                    </Tab>
                )}
            </Tabs>
        </Block>

    )
}
const tabPanelStyle = {
    TabPanel: {
        style: ({ $theme }) => ({
            height: "100%"
        })
    },
}

const defaultFilter = (app: IAutomationObject) => {
    return true;
}

function GroupView({ objects, object, small }) {
    const [css, theme] = useStyletron();
    const [search, setSearch] = useState("");
    const onSearchChanged = (e: any) => setSearch(e.target.value)

    const items = useMemo(() => {
        return objects ?
            objects.slice().filter((a: any) => a.name.toLowerCase().includes(search) || a.schema.toLowerCase().includes(search) || a.description.toLowerCase().includes(search))
            : null;
    }, [objects, search]);


    return (
        <Block height={'100%'} gridGap={theme.sizing.scale400} display='flex' flexDirection={'column'}>
            <div className={css({ display: 'contents' })}>
                <div className={css({ flex: '0 1 auto' })}>
                    <Input
                        endEnhancer={<Search size="18px" />}
                        placeholder="Search..."
                        onChange={onSearchChanged}
                    />
                </div>
                <div className={css({
                    overflowY: "auto",
                    flex: '1 1 auto'
                })}>
                    <FlexGrid flexGridColumnCount={[1, 1, 2, 4]}
                        flexGridColumnGap="scale200"
                        flexGridRowGap="scale400">
                        {items?.map((item: any, index: number) => {
                            const state = {
                                ...item,
                                ...item.defaultState
                            };
                            return (
                                <FlexGridItem >
                                    <ObjectCreateItem key={item.name} item={item} object={object} small={small}>
                                        {item.panel && <SelectPanel defaultState={state} panel={item.panel}></SelectPanel>}
                                        {!item.panel && <ObjectHeader name={item.schema} description={item.name}></ObjectHeader>}
                                    </ObjectCreateItem>
                                </FlexGridItem>
                            )
                        })}
                    </FlexGrid>
                </div>
            </div>
        </Block>
    )
}

function SelectPanel({ panel, defaultState }): any {
    const tmp = panel;
    if (!tmp)
        return <UnknownAutomationObject  {...defaultState}></UnknownAutomationObject>

    const MyNewComponent = tmp;
    return <MyNewComponent {...defaultState} small />
}



const ObjectCreateItem = ({ children, item, object, small }: any) => {
    const spanType = small ? [12, 12, 12] : [12, 4, 3]
    return (


        <RenderIfVisible defaultHeight={400} visibleOffset={500} stayRendered>
            <Card>
                <StyledBody>
                    {children}
                </StyledBody>
                <StyledAction>
                    <CreateObjectDialog schema={item.schema} defaultProperties={item.defaultProperties} object={object}></CreateObjectDialog>
                </StyledAction>
            </Card>
        </RenderIfVisible>

    );
}

function sort(a, b): number {
    return a.description.localeCompare(b.description)
}
function sortSchema(a, b): number {
    return a.schema.localeCompare(b.schema)
}
